(function () {
  var sectionStates = new WeakMap();

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseTime(value) {
    if (!value) return null;
    var time = new Date(value).getTime();
    return Number.isNaN(time) ? null : time;
  }

  function clearState(section) {
    var state = sectionStates.get(section);
    if (!state) return;

    state.timers.forEach(function (timer) {
      if (timer.type === 'interval') {
        window.clearInterval(timer.id);
      } else {
        window.clearTimeout(timer.id);
      }
    });

    sectionStates.delete(section);
  }

  function setCardLive(card) {
    card.classList.remove('is-locked');
    card.classList.add('is-live');

    var badgeText = card.querySelector('[data-bw-badge-text]');
    var liveBadge = card.getAttribute('data-live-badge-text');
    if (badgeText && liveBadge) badgeText.textContent = liveBadge;

    card.querySelectorAll('[data-bw-unlock-link], [data-bw-image-link]').forEach(function (link) {
      var href = link.getAttribute('data-live-href');
      if (href && href !== '#') {
        link.setAttribute('href', href);
      }
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
    });
  }

  function setCardLocked(card) {
    card.classList.remove('is-live');
    card.classList.add('is-locked');

    card.querySelectorAll('[data-bw-unlock-link], [data-bw-image-link]').forEach(function (link) {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    });
  }

  function getCards(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-bw-drop-card]')).map(function (card) {
      return {
        el: card,
        scheduled: card.getAttribute('data-scheduled') === 'true',
        time: parseTime(card.getAttribute('data-drop-at')),
        title: card.getAttribute('data-title') || '',
        dayLabel: card.getAttribute('data-day-label') || '',
        anchor: card.getAttribute('data-bw-anchor') || ''
      };
    });
  }

  function updateScheduleLinks(section, cards) {
    var liveText = section.getAttribute('data-live-text') || 'Live Now';
    var comingSoonText = section.getAttribute('data-coming-soon-text') || 'Coming Soon';

    section.querySelectorAll('[data-bw-schedule-link]').forEach(function (link) {
      var target = link.getAttribute('data-target');
      var card = cards.find(function (item) {
        return item.anchor === target;
      });
      var status = link.querySelector('[data-bw-schedule-status]');

      if (!card) return;

      if (card.el.classList.contains('is-live')) {
        link.classList.add('is-live');
        link.classList.remove('is-locked');
        if (status) status.textContent = liveText;
      } else {
        link.classList.remove('is-live');
        link.classList.add('is-locked');
        if (status) status.textContent = comingSoonText;
      }
    });
  }

  function updateCountdown(section, cards, loadTime) {
    var countdown = section.querySelector('[data-bw-countdown]');
    if (!countdown) return;

    var now = Date.now();
    var upcoming = cards
      .filter(function (item) {
        return item.scheduled && item.time && item.time > now;
      })
      .sort(function (a, b) {
        return a.time - b.time;
      });

    var title = countdown.querySelector('[data-bw-next-title]');
    var dayNode = countdown.querySelector('[data-bw-days]');
    var hourNode = countdown.querySelector('[data-bw-hours]');
    var minuteNode = countdown.querySelector('[data-bw-minutes]');
    var secondNode = countdown.querySelector('[data-bw-seconds]');

    if (!upcoming.length) {
      if (title) title.textContent = countdown.getAttribute('data-complete-message') || 'All drops are live.';
      if (dayNode) dayNode.textContent = '00';
      if (hourNode) hourNode.textContent = '00';
      if (minuteNode) minuteNode.textContent = '00';
      if (secondNode) secondNode.textContent = '00';
      return;
    }

    var next = upcoming[0];
    var distance = Math.max(0, next.time - now);
    var days = Math.floor(distance / 86400000);
    var hours = Math.floor((distance % 86400000) / 3600000);
    var minutes = Math.floor((distance % 3600000) / 60000);
    var seconds = Math.floor((distance % 60000) / 1000);

    if (title) title.textContent = next.dayLabel + ' — ' + next.title;
    if (dayNode) dayNode.textContent = pad(days);
    if (hourNode) hourNode.textContent = pad(hours);
    if (minuteNode) minuteNode.textContent = pad(minutes);
    if (secondNode) secondNode.textContent = pad(seconds);
  }

  function updateSection(section, loadTime) {
    var now = Date.now();
    var cards = getCards(section);

    cards.forEach(function (item) {
      var wasLocked = item.el.classList.contains('is-locked');

      if (!item.scheduled || !item.time || now >= item.time) {
        setCardLive(item.el);

        if (
          wasLocked &&
          item.scheduled &&
          item.time &&
          section.getAttribute('data-refresh-at-launch') === 'true' &&
          loadTime < item.time
        ) {
          var refreshKey = 'birthday-week-refresh-' + section.getAttribute('data-section-id') + '-' + item.time;
          if (!window.localStorage.getItem(refreshKey)) {
            window.localStorage.setItem(refreshKey, '1');
            window.setTimeout(function () {
              window.location.reload();
            }, 400);
          }
        }
      } else {
        setCardLocked(item.el);
      }
    });

    updateScheduleLinks(section, cards);
    updateCountdown(section, cards, loadTime);
  }

  function initMorpher(section, state) {
    var morpher = section.querySelector('[data-bw-morpher]');
    if (!morpher) return;

    var sourceLines = Array.prototype.slice.call(morpher.querySelectorAll('span'))
      .map(function (line) { return line.textContent.trim(); })
      .filter(Boolean);

    if (!sourceLines.length) return;

    morpher.innerHTML = '';

    var renderedLines = sourceLines.map(function (line, index) {
      var item = document.createElement('div');
      item.className = 'birthday-week-morpher__item' + (index === 0 ? ' is-active' : '');
      item.textContent = line;
      morpher.appendChild(item);
      return item;
    });

    var currentIndex = 0;
    var speed = parseInt(morpher.getAttribute('data-speed'), 10) || 1400;

    if (renderedLines.length < 2) return;

    var interval = window.setInterval(function () {
      renderedLines[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % renderedLines.length;
      renderedLines[currentIndex].classList.add('is-active');
    }, speed);

    state.timers.push({ id: interval, type: 'interval' });
  }

  function initSection(section) {
    clearState(section);

    var state = { timers: [] };
    var loadTime = Date.now();
    sectionStates.set(section, state);

    var liveTextSetting = section.querySelector('[data-bw-schedule]');
    section.setAttribute('data-live-text', section.dataset.liveText || 'Live Now');
    section.setAttribute('data-coming-soon-text', section.dataset.comingSoonText || 'Coming Soon');
    if (liveTextSetting) {
      section.setAttribute('data-live-text', section.getAttribute('data-live-text'));
    }

    initMorpher(section, state);
    updateSection(section, loadTime);

    var interval = window.setInterval(function () {
      updateSection(section, loadTime);
    }, 1000);

    state.timers.push({ id: interval, type: 'interval' });
  }

  function initAll() {
    document.querySelectorAll('[data-birthday-week-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-birthday-week-section]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-birthday-week-section]');
    if (section) clearState(section);
  });
})();
